<template>
    <svg
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        :style="{ backgroundColor }"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M23.9943 23.5826C21.5832 23.5826 19.6136 22.8186 18.0856 21.2905C16.5575 19.7624 15.7935 17.7929 15.7935 15.3818C15.7935 12.9707 16.5575 10.9992 18.0856 9.46729C19.6136 7.93539 21.5832 7.16943 23.9943 7.16943C26.4054 7.16943 28.3816 7.93539 29.9229 9.46729C31.4642 10.9992 32.2348 12.9707 32.2348 15.3818C32.2348 17.7929 31.4642 19.7624 29.9229 21.2905C28.3816 22.8186 26.4054 23.5826 23.9943 23.5826ZM7.29346 41.0739V35.6167C7.29346 34.2274 7.64619 33.0242 8.35166 32.0071C9.05712 30.9901 9.96961 30.2174 11.0891 29.6891C13.3601 28.6703 15.5485 27.9061 17.6543 27.3967C19.76 26.8873 21.8727 26.6326 23.9924 26.6326C26.1482 26.6326 28.2689 26.8956 30.3544 27.4217C32.4399 27.9478 34.6074 28.7068 36.8569 29.6988C38.0248 30.2066 38.9631 30.9692 39.6718 31.9867C40.3805 33.0043 40.7348 34.2118 40.7348 35.6093V41.0739H7.29346ZM11.2544 37.113H36.7457V35.7239C36.7457 35.2028 36.5873 34.7055 36.2707 34.2322C35.954 33.7588 35.5623 33.4082 35.0957 33.1804C33.0377 32.2036 31.149 31.533 29.4295 31.1685C27.71 30.804 25.8955 30.6217 23.986 30.6217C22.1142 30.6217 20.2924 30.804 18.5207 31.1685C16.7489 31.533 14.8642 32.2022 12.8665 33.176C12.3917 33.404 12.0044 33.7551 11.7044 34.2293C11.4044 34.7035 11.2544 35.2017 11.2544 35.7239V37.113ZM23.9943 19.6216C25.2227 19.6216 26.2384 19.2217 27.0413 18.4217C27.8442 17.6217 28.2457 16.6068 28.2457 15.377C28.2457 14.1395 27.8461 13.1223 27.0471 12.3255C26.248 11.5288 25.2342 11.1304 24.0058 11.1304C22.7773 11.1304 21.7616 11.5292 20.9587 12.3268C20.1558 13.1245 19.7544 14.1365 19.7544 15.363C19.7544 16.5973 20.1539 17.6156 20.953 18.418C21.752 19.2204 22.7658 19.6216 23.9943 19.6216Z"
            fill="currentColor" />
    </svg>
</template>

<script lang="ts">
    import { defineComponent } from 'vue';

    export default defineComponent({
        props: {
            backgroundColor: {
                type: String,
                required: true,
            },
        },
    });
</script>
